import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const COW_DEF: MobDef = {
  name: 'Cow',
  width: 0.6,
  height: 1.1,
  health: 10,
  speed: 1.3,
  hostile: false,
  color: 0x443322,
  bodyColor: 0x664433,
  detectionRange: 0,
  attackDamage: 0,
  attackRange: 0,
  drops: [
    { id: BlockId.DIRT, min: 1, max: 3 }, // leather placeholder (using dirt)
  ],
};
